import React from "react";
import { Card, Form } from "react-bootstrap";

interface StudentDetailsCardProps {
  schoolType: "osnovna" | "srednja";
  setSchoolType: (type: "osnovna" | "srednja") => void;
  selectedGrade: string | null;
  setSelectedGrade: (grade: string) => void;
  notes: string;
  setNotes: (notes: string) => void;
  notesTouched: boolean;
  setNotesTouched: (touched: boolean) => void;
}

const StudentDetailsCard: React.FC<StudentDetailsCardProps> = ({
  schoolType,
  setSchoolType,
  selectedGrade,
  setSelectedGrade,
  notes,
  setNotes,
  notesTouched,
  setNotesTouched,
}) => {
  return (
    <Card className="mb-4 shadow-sm">
      <Card.Header className="bg-light">
        <h5 className="mb-0">Detalji o učeniku</h5>
      </Card.Header>
      <Card.Body>
        <Form.Group className="mb-4">
          <Form.Label className="fw-bold">
            Razred učenika <span className="text-danger">*</span>
          </Form.Label>
          <Card className="p-3">
            <div className="mb-3">
              <Form.Check
                inline
                type="radio"
                name="schoolType"
                id="osnovnaSkola"
                label="Osnovna škola"
                checked={schoolType === "osnovna"}
                onChange={() => setSchoolType("osnovna")}
                className="me-3"
              />
              <Form.Check
                inline
                type="radio"
                name="schoolType"
                id="srednjaSkola"
                label="Srednja škola"
                checked={schoolType === "srednja"}
                onChange={() => setSchoolType("srednja")}
              />
            </div>

            <div className="d-flex flex-wrap">
              {schoolType === "osnovna"
                ? Array.from({ length: 8 }, (_, i) => (
                    <Form.Check
                      key={`osnovna-${i + 1}`}
                      type="radio"
                      name="grade"
                      id={`osnovna-${i + 1}`}
                      label={`${i + 1}. razred`}
                      checked={selectedGrade === `${i + 1}`}
                      onChange={() => setSelectedGrade(`${i + 1}`)}
                      className="me-3 mb-2"
                    />
                  ))
                : Array.from({ length: 4 }, (_, i) => (
                    <Form.Check
                      key={`srednja-${i + 1}`}
                      type="radio"
                      name="grade"
                      id={`srednja-${i + 1}`}
                      label={`${i + 1}. razred`}
                      checked={selectedGrade === `${i + 1}`}
                      onChange={() => setSelectedGrade(`${i + 1}`)}
                      className="me-3 mb-2"
                    />
                  ))}
            </div>
            {!selectedGrade && notesTouched && (
              <div className="text-danger mt-2">Odabir razreda je obavezan</div>
            )}
          </Card>
        </Form.Group>

        <Form.Group className="mb-3" controlId="formNotes">
          <Form.Label className="fw-bold">
            Napomena <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            placeholder="Unesite iz kojeg gradiva želite poduke i dodatne informacije"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            onBlur={() => setNotesTouched(true)}
            isInvalid={notesTouched && !notes.trim()}
          />
          <Form.Control.Feedback type="invalid">
            Napomena je obavezna. Molimo navedite iz kojeg gradiva želite
            poduku.
          </Form.Control.Feedback>
        </Form.Group>

        {!selectedGrade && notesTouched && !notes.trim() && (
          <div className="text-danger mb-3">
            Potrebno je odabrati razred i unijeti napomenu
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default StudentDetailsCard;
